import { useState } from "react";
import AllPcode from "../../components/userPcode";
import LocationTypeSearch from "../../components/locationTypeSearch";
import CategoryTypeSearch from "../../components/categoryTypeSearch/categoryTypeSearch";
import SubCategoryTypeSearch from "../../components/subCategoryTypeSearch/subCategoryTypeSearch";
import ItemTypeSearch from "../../components/itemTypeSearch";
import { stockAPI } from "../../api/stockAPI";
import { OpenReport } from "../../utils/openReport";
import Spinner from "../../components/spinner/spinner";
import { toast } from "react-toastify";

export default function StockBalanceRpt() {
    const [selectedPcode, setSelectedPcode] = useState('');
    const [locCode, setLocCode] = useState('');
    const [locName, setLocName] = useState('');
    const [catCode, setCatCode] = useState('');
    const [catName, setCatName] = useState('');
    const [subCatCode, setSubCatCode] = useState('');
    const [subCatName, setSubCatName] = useState('');
    const [itemCode, setItemCode] = useState('');
    const [itemName, setItemName] = useState('');
    const [isAllLocCodeChecked, setIsAllLocCodeChecked] = useState(true);
    const [isAllCatCodeChecked, setIsAllCatCodeChecked] = useState(true);
    const [isAllSubCatCodeChecked, setIsAllSubCatCodeChecked] = useState(true);
    const [isAllItemCodeChecked, setIsAllItemCodeChecked] = useState(true);
    const currentDate = new Date();
    const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);
    const [loading, setLoading] = useState(false);

    const formatDate = (date) => {
        return date.toISOString().split('T')[0];
    };

    // Handle Location  change
    const handleLocationChange = (e) => {
        setIsAllLocCodeChecked(e.target.checked);
        if (e.target.checked) {
            setLocCode('');
            setLocName('');
        }
    };

    // Handle Category  change
    const handleCategoryChange = (e) => {
        setIsAllCatCodeChecked(e.target.checked);
        if (e.target.checked) {
            setCatCode('');
            setCatName('');
        }
    };

    // Handle Sub-Category  change
    const handleSubCategoryChange = (e) => {
        setIsAllSubCatCodeChecked(e.target.checked);
        if (e.target.checked) {
            setSubCatCode('');
            setSubCatName('');
        }
    };

    // Handle Item  change
    const handleItemChange = (e) => {
        setIsAllItemCodeChecked(e.target.checked);
        if (e.target.checked) {
            setItemCode('');
            setItemName('');
        }
    };

    const handleClear = () => {
        setLocCode('');
        setLocName('');
        setCatCode('');
        setCatName('');
        setSubCatCode('');
        setSubCatName('');
        setItemCode('');
        setItemName('');
        setToDate(currentDate.toISOString().split('T')[0]);

        setIsAllLocCodeChecked(true);
        setIsAllCatCodeChecked(true);
        setIsAllSubCatCodeChecked(true);
        setIsAllItemCodeChecked(true);

    }

    const handlePreviewRpt = () => {
        setLoading(true);

        if (!isAllLocCodeChecked && !locCode) {
            toast.warning("Select the location");
            setLoading(false);
            return;
        }
        if (!isAllCatCodeChecked && !catCode) {
            toast.warning("Select the category");
            setLoading(false);
            return;
        }
        if (!isAllSubCatCodeChecked && !subCatCode) {
            toast.warning("Select the sub category");
            setLoading(false);
            return;
        }
        if (!isAllItemCodeChecked && !itemCode) {
            toast.warning("Select the item");
            setLoading(false);
            return;
        }
        if (!toDate) {
            toast.warning("To date is required");
            setLoading(false);
            return;
        }

        const formattedToDate = new Date(toDate).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
        const reportName = `Stock Balance Report - ${formattedToDate}.pdf`;
        stockAPI.getStockDetailsRpt(selectedPcode, locCode, locName, catCode, subCatCode, itemCode, toDate)
            .then((response) => {
                if (response.report) {
                    OpenReport(response.report, reportName);
                    handleClear();
                } else {
                    console.error("No report data found");
                }
            })
            .catch((error) => {
                console.error("Error fetching report data:", error);
            }).finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            {
                selectedPcode &&
                <LocationTypeSearch setLocCode={setLocCode} setLocName={setLocName}
                    pCode={selectedPcode}
                    setIsAllLocationsChecked={setIsAllLocCodeChecked} />
            }
            {
                selectedPcode &&
                <CategoryTypeSearch setCatCode={setCatCode} setCatName={setCatName}
                    pCode={selectedPcode}
                    setIsAllCategoriesChecked={setIsAllCatCodeChecked} />
            }
            {
                selectedPcode &&
                <SubCategoryTypeSearch setSubCatCode={setSubCatCode} setSubCatName={setSubCatName}
                    pCode={selectedPcode}
                    setIsAllSubCategoriesChecked={setIsAllSubCatCodeChecked} />
            }
            {
                selectedPcode &&
                <ItemTypeSearch setItemCode={setItemCode} setItemName={setItemName}
                    pCode={selectedPcode}
                    setIsAllItemChecked={setIsAllItemCodeChecked} />
            }

            {loading && (
                <div className="loading-overlay">
                    <Spinner />
                    <div>Loading...</div>
                </div>
            )}
            {!loading && (
                <div className="container">
                    <div className='row'>
                        <div className='col-xs-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 form__body'>
                            <h6 className='text-center'>Stock</h6>
                            <form>
                                <div class="form-group row">
                                    <label for="staticEmail" class="col-xs-12 col-sm-12 col-md-6 col-lg-12 col-xl-12 col-form-label">Profit Center</label>
                                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-11 col-xl-11 ">
                                        <AllPcode setSelectedPcode={setSelectedPcode} />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail" class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-form-label">Location</label>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                                        <input type="text" class="form-control" id="inputPassword" value={locCode} />
                                    </div>
                                    <div className="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 text-center px-0">
                                        <button type="button" className="btn btn-sm btn-secondary m-0 px-sm-1" data-bs-toggle="modal"
                                            data-bs-target="#locationTypeSearch"><span className="small">Find</span></button>
                                    </div>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-6 col-xl-6">
                                        <input type="text" class="form-control" id="inputPassword"
                                            value={locName}
                                            onChange={(e) => setLocName(e.target.value)} />
                                    </div>
                                    <div class="col-2 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked"
                                            checked={isAllLocCodeChecked}
                                            onChange={handleLocationChange} />
                                        <label class="form-check-label" for="flexCheckChecked">
                                            All
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail" class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-form-label">Category</label>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                                        <input type="text" class="form-control" id="inputPassword" value={catCode} />
                                    </div>
                                    <div className="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 text-center px-0">
                                        <button type="button" className="btn btn-sm btn-secondary m-0 px-sm-1" data-bs-toggle="modal"
                                            data-bs-target="#categoryTypeSearch"><span className="small">Find</span></button>
                                    </div>
                                    <div class="col-9  col-xs-12 col-sm-12 col-md-3 col-lg-6 col-xl-6">
                                        <input type="text" class="form-control" id="inputPassword" value={catName} />
                                    </div>
                                    <div class="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked"
                                            checked={isAllCatCodeChecked}
                                            onChange={handleCategoryChange} />
                                        <label class="form-check-label" for="flexCheckChecked">
                                            All
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail" class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-form-label">Sub Category</label>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                                        <input type="text" class="form-control" id="inputPassword" value={subCatCode} />
                                    </div>
                                    <div className="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 text-center px-0">
                                        <button type="button" className="btn btn-sm btn-secondary m-0 px-sm-1" data-bs-toggle="modal"
                                            data-bs-target="#subCategoryTypeSearch"><span className="small">Find</span></button>
                                    </div>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-6 col-xl-6">
                                        <input type="text" class="form-control" id="inputPassword" value={subCatName} />
                                    </div>
                                    <div class="col-2 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked"
                                            checked={isAllSubCatCodeChecked}
                                            onChange={handleSubCategoryChange}
                                        />
                                        <label class="form-check-label" for="flexCheckChecked">
                                            All
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail" class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-form-label">Item</label>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                                        <input type="text" class="form-control" id="inputPassword" value={itemCode} />
                                    </div>
                                    <div className="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 text-center px-0">
                                        <button type="button" className="btn btn-sm btn-secondary m-0 px-sm-1" data-bs-toggle="modal"
                                            data-bs-target="#itemTypeSearch"><span className="small">Find</span></button>
                                    </div>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-6 col-xl-6">
                                        <input type="text" class="form-control" id="inputPassword" value={itemName} />
                                    </div>
                                    <div class="col-2 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked"
                                            checked={isAllItemCodeChecked}
                                            onChange={handleItemChange} />
                                        <label class="form-check-label" for="flexCheckChecked">
                                            All
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail" class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-form-label">To Date</label>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <input type="date" class="form-control" id="inputPassword"
                                            value={toDate}
                                            onChange={(e) => setToDate(e.target.value)} />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                                        <button type="button" className="btn btn-dark form-control mt-1" onClick={handlePreviewRpt}>Preview</button>
                                    </div>
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                                        <button type="button" className="btn btn-secondary form-control mt-1" onClick={handleClear} >Clear</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className='col-xs-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                    </div>
                </div>
            )}
        </>
    );
}